module.exports = "/assets/data/9d8802f5ece94199154b9ab5db4e4040-IV30.data.json";